export function getServerName() {
  if (window.location.host === 'app.matemati.co') {
    return 'Matematico';
  }

  if (window.location.host === 'app.exami.co') {
    return 'Examico';
  }

  if (process.env.REACT_APP_EXAMICO === 'true') {
    return 'Examico';
  }

  return 'Matematico';
}
